import { all } from "@redux-saga/core/effects";

import { userAgentsEntriesSagas } from "modules/UserAgents/services/UserAgents/sagas";

export function* userAgentsSaga() {
    yield all([
        userAgentsEntriesSagas()
    ]);
}